import { observer } from "mobx-react-lite";
import { useContext } from "react";

import { ConfirmDialog } from "@bps/fluent-ui";
import { InboxScreenContext } from "@modules/inbox/screens/context/InboxScreenContext.ts";
import { usePatientLabel } from "@ui-components/hooks/usePatientLabel.ts";

export const ClinicalReminderSendWarningDialog: React.FC = observer(() => {
  const {
    setReminderSendWarningVisible,
    sendSelectedReminders,
    reminderSendWarningVisible
  } = useContext(InboxScreenContext);

  const patientLabel = usePatientLabel();

  return (
    <ConfirmDialog
      onConfirm={() => {
        sendSelectedReminders();
        setReminderSendWarningVisible(false);
      }}
      hidden={!reminderSendWarningVisible}
      onCancel={() => {
        setReminderSendWarningVisible(false);
      }}
      dialogContentProps={{ showCloseButton: true, title: "Send" }}
      confirmButtonProps={{
        text: "Send available"
      }}
    >
      Some of the selected {patientLabel}(s) have no mobile number recorded.
      Only those with mobile number present will be automatically processed
    </ConfirmDialog>
  );
});
